const colours = {
  green: {
    5: "#EAFCF2",
    10: "#D6F8E5",
    20: "#AEEAC9",
    30: "#89D0A9",
    40: "#66A984",
    50: "#417257",
    60: "#1c3327",
  },
}

export default colours
